import { getFilename } from "@/utils/path"
export { splitWorkspace, joinWorkspace, stripWorkspace } from "@/sdk/v2/workspace"
import { splitWorkspace } from "@/sdk/v2/workspace"

export function workspaceTitle(dir: string | undefined, fallback = "") {
  const { root } = splitWorkspace(dir)
  return getFilename(root) || fallback
}

export const workspaceKey = (directory: string) => {
  return directory.replace(/[\\/]+$/, "")
}

export const workspaceMatches = (session: { workspaceID?: string }, workspaceID: string) => {
  return session.workspaceID === workspaceID
}
